<template>
    <div class="container">
        <h1>Configure Cameras</h1>
        <b-tabs position="is-centered" class="block" v-model="activeTab">
            <b-tab-item label="List">
                <b-table
                        v-if="cameras.length > 0"
                        :striped="true"
                        :narrowed="true"
                        :data="cameras"
                        default-sort-direction="desc"
                >
                    <template slot-scope="props">
                        <b-table-column label="Camera" field="name">
                            <router-link :to="{path: '/configure/cameras/' + props.row.id}">{{props.row.name}}
                            </router-link>
                        </b-table-column>
                    </template>
                </b-table>
                <div v-else class="margin_top_1rem">No cameras defined.</div>
            </b-tab-item>
            <b-tab-item label="Add Camera">
                <div class="container has-text-left margin_top_1rem">
                    <b-field label="Name">
                        <b-input v-model="name" required placeholder="Enter camera name"></b-input>
                    </b-field>
                    <div class="buttons">
                        <b-button type="is-success" :disabled="!validFields()" @click="handleAddCamera">Create
                        </b-button>
                    </div>
                </div>
            </b-tab-item>
        </b-tabs>
    </div>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex';
  import BTable from "buefy/src/components/table/Table";
  import BTableColumn from "buefy/src/components/table/TableColumn";
  import BField from "buefy/src/components/field/Field";
  import BButton from "buefy/src/components/button/Button";

  export default {
    name: "screenconfigurecameras",
    components: {
      BButton,
      BField,
      BTableColumn,
      BTable
    },
    data() {
      return {
        activeTab: 0,
        name: ''
      };
    },
    computed: {
      ...mapGetters('cameras', ['cameras'])
    },
    methods: {
      ...mapActions('cameras', ['addCamera']),
      validFields() {
        if (!this.name || this.name.length < 1) {
          return false;
        }
        return true;
      },
      resetFields() {
        this.name = '';
      },
      handleAddCamera() {
        this.addCamera({
          name: this.name
        });
        this.resetFields();
        this.activeTab = 0;
      }
    },
    mounted() {
    }
  }
</script>

<style scoped>
    h1 {
        font-size: 1.5rem;
        font-weight: bold;
        margin-top: 0.75rem;
        margin-bottom: 0.75rem;
    }

    .margin_top_1rem {
        margin-top: 1rem;
    }
</style>